// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"55":"dda3094864d90ba30fda","924":"c9dbc56ad0d70a416fef","925":"f1a84fffca77a1e4ac40"}[chunkId] + ".js";
};